<div mat-dialog-title class="confirmHeader pt-3 mt-2 pb-0 d-flex justify-content-center">
    <img [src]="icon" alt="Alert"
        [class]="(data.action === 'Delete' || data.continue === 'Delete') ? 'delete-icon' : 'warning-icon'">
</div>
<div class="d-flex justify-content-center" *ngIf="data.header && data.header !='Extraction Procedure'">
    <h1 class="main-line-text m-0">{{data.header}}</h1>
</div>
<span class="migrate_wrap">
    <div mat-dialog-content class="align-center"
        *ngIf="data.message === 'CHANGES_DISCARDED_FORMAT' || (data.action === 'Delete' && data.username)">
        <span *ngIf="data.message === 'CHANGES_DISCARDED_FORMAT'" class="message">
            <span class="main-line-text align-center">Changes will be discarded</span>
            <span class="sub-line-text align-center">Do you wish to proceed?</span>
        </span>

        <span *ngIf="data.action === 'Delete' && data.username" class="align-center">
            <span class="sub-line-text">{{data.username || 'User'}}</span>
        </span>
    </div>

    <div mat-dialog-content
        *ngIf="data.message !== 'CHANGES_DISCARDED_FORMAT' && !(data.action === 'Delete' && data.username) && !data?.subText"
        class="main-line-txt-align align-center">
        <span [innerText]="data.message" class="message"></span>
        <h5 *ngIf="data.alert">{{data.alert}}</h5>
        <span class="sub-line-text" *ngIf="ifExists(data.message)">You cannot revert this action.</span>
        <h6 *ngIf="data.notes">{{data.notes}}</h6>
        <section *ngIf="data.action" class="example-section">
            <mat-checkbox class="example-margin" [color]="'primary'" (change)='onCheckboxClick($event.checked)'>
                {{data.action}}</mat-checkbox>
        </section>
    </div>

    <div mat-dialog-content class="align-center"
        *ngIf="data.message !== 'CHANGES_DISCARDED_FORMAT' && !(data.action === 'Delete' && data.username) && data?.subText">
        <span class="message">
            <span class="main-line-text align-center">{{ data.message }}</span>
            <span class="sub-line-text align-center">{{ data?.subText }}</span>
        </span>
    </div>
</span>

<div mat-dialog-actions class="confirm_dia d-flex justify-content-center"
    [ngClass]="{'pb-4': data.alert && data.alert.includes('previous record will be unmarked')}"
    [ngStyle]="{'justify-content': data.cancel === 'dontshow' ? 'center':''}">

    <app-button *ngIf="data.cancel !== 'dontshow'" buttonclass="secondary" class="mr-3 popup-btn" customClass="admin"
        mat-dialog-close>{{data.cancel}}</app-button>
    <!-- <button *ngIf="data.cancel !== 'dontshow'" type="button" [mat-dialog-close]="data.animal" cdkFocusInitial
        class="md-btn md-flat mb-0 p-t-xs p-b-xs p-l-sm p-r-sm m-r-xs mr-4 cancelButton">
        {{data.cancel}}
    </button> -->

    <!-- Delete button for delete actions -->
    <app-button *ngIf="data.action === 'Delete' && data.continue" class="popup-btn delete-button" customClass="admin"
        [isDisabled]="!isActionChecked && data.message.includes('offline!')"
        (click)="onNoClick()">{{getButtonText()}}</app-button>

    <!-- Regular button for all other cases except delete actions -->
    <app-button
        *ngIf="data.header !='Extraction Procedure' && data.action !== 'Delete' && data.continue && data.continue !== 'Delete'"
        buttonclass="primary" class="popup-btn" customClass="admin"
        [isDisabled]="!isActionChecked && data.message.includes('offline!')"
        (click)="onNoClick()">{{getButtonText()}}</app-button>

    <app-button *ngIf="data.action !== 'Delete' && data.continue && data.continue === 'Delete'"
        class="popup-btn delete-button" customClass="admin"
        [isDisabled]="!isActionChecked && data.message.includes('offline!')"
        (click)="onNoClick()">{{getButtonText()}}</app-button>

    <!-- <button *ngIf="data.header !='Extraction Procedure'" type="submit" class="md-btn md-flat mb-0 p-t-xs p-b-xs p-l-sm p-r-sm m-r-xs ml-3 confirmButton"
        (click)="onNoClick()">
        {{data.continue}}
    </button> -->

    <div *ngIf="data.header == 'Extraction Procedure'" class="d-flex ml-4">
        <mat-icon role="img" class="align-items-center redirect-icon">launch</mat-icon>
        <a class="redirect-btn mr-3" (click)="onNoClick()"> {{data.continue}}</a>
    </div>
</div>